export const HEADER_HEIGHT = 8;
export const SOHO_FASHION_CATEGORY = {
  keys: ['fashion_clothing', 'fashion_goods'],
  ids: [3573, 3574],
};

export const maxTabCountSizeMedium = 4;
